<template>
  <div>
    <ViewResidentMonitoredHealth :resident_id="resident_id" />
  </div>
</template>

<script>
import routes from "../../../routes";

import ViewResidentMonitoredHealth from "../../ResidentMonitoredHealth/View";

export default {
  name: "ResidentMonitoredHealth",

  components: {
    ViewResidentMonitoredHealth,
  },

  data() {
    return {
      resident_id: "",
    };
  },

  created() {
    this.retrieve();
  },

  methods: {
    retrieve() {
      const { id } = routes.history.current.params;
      this.resident_id = id;
    },
  },
};
</script>